<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        :value="displayValue"
        :label="computedLabel"
        :rules="rules"
        :readonly="readonly"
        :outlined="outlined"
        :dense="dense"
        :disabled="disabled"
        :clearable="clearable"
        :prepend-icon="prependIcon"
        :append-icon="appendIcon"
        v-bind="attrs"
        v-on="on"
        @click:clear="clear"
      >
        <template v-if="$slots.label" #label>
          <slot name="label" />
        </template>
      </v-text-field>
    </template>

    <v-date-picker
      v-model="selectedDate"
      :min="min"
      :max="max"
      :first-day-of-week="1"
      no-title
      scrollable
    />
  </v-menu>
</template>

<script>
import moment from "moment";

export default {
  name: "DatePickerInput",

  model: {
    prop: "value",
    event: "input",
  },

  props: {
    value: {
      type: String,
      default: "",
    },

    label: {
      type: String,
      default: "",
    },

    rules: {
      type: Array,
      default: () => [],
    },

    min: {
      type: String,
      default: null,
    },

    max: {
      type: String,
      default: () => new Date().toISOString().substr(0, 10),
    },

    dense: {
      type: Boolean,
      default: true,
    },

    outlined: {
      type: Boolean,
      default: true,
    },

    readonly: {
      type: Boolean,
      default: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: false,
    },

    prependIcon: {
      type: String,
      default: "",
    },

    appendIcon: {
      type: String,
      default: "",
    },

    required: {
      type: Boolean,
      default: false,
    },

    format: {
      type: String,
      default: "YYYY-MM-DD",
    },

    displayFormat: {
      type: String,
      default: "YYYY-MM-DD",
      // Examples:
      // "DD/MM/YYYY"
      // "MMM DD, YYYY"
      // "MMMM Do YYYY"
    },
  },

  data() {
    return {
      menu: false,
    };
  },

  computed: {
    selectedDate: {
      get() {
        if (this.value === "0001-01-01") return "";

        return this.value;
      },
      set(value) {
        this.$emit("input", value);
        this.$emit("change", value);
        this.menu = false;
      },
    },

    displayValue() {
      if (!this.value) {
        return "";
      }

      return moment(this.value, this.format).format(this.displayFormat);
    },

    computedLabel() {
      if (!this.required) {
        return this.label;
      }

      return `${this.label} *`;
    },
  },

  methods: {
    selectDate(date) {
      this.$emit("input", date);
      this.$emit("change", date);

      this.menu = false;
    },

    clear() {
      this.$emit("input", "");
      this.$emit("change", "");
    },

    focus() {
      this.menu = true;
    },

    validate() {
      return this.$refs.input ? this.$refs.input.validate() : true;
    },

    reset() {
      this.clear();
    },
  },
};
</script>
